// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__SthT8","title":"Header_title__sfNsH","side":"Header_side__3Te7H"};